// import "./App.css";
// import { useState } from "react";
// import Board from "./Board.js";
// import YamlEditor from "./YamlEditor.js";
// import { dummyYaml, dummyData, dummySettings } from "./DummyData.js";

// function App() {
//   const [yaml, setYaml] = useState(dummyYaml());
//   const [data, setData] = useState(dummyData());
//   const [settings, setSettings] = useState(dummySettings());

//   return (
//     <div className="App">
//       <div className="display-flex full-height">
//         <div>
//           <YamlEditor
//             value={yaml}
//             onChanged={(newData, newSettings) => {
//               setData(newData);
//               setSettings(newSettings);
//             }}
//           ></YamlEditor>
//         </div>
//         <div>
//           {data != null && (
//             <Board
//               data={data}
//               settings={settings}
//               onDataChanged={() => {
//                 console.log("Not Implemented.");
//               }}
//             ></Board>
//           )}
//           {
//             // <pre>{JSON.stringify(settings, null, 2)}</pre>
//           }
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import { useState } from "react";
import Board from "./Board.js";
import YamlEditor from "./YamlEditor.js";
import { dummyYaml, dummyData, dummySettings } from "./DummyData.js";

function App() {
  const [yaml, setYaml] = useState(dummyYaml());
  const [data, setData] = useState(dummyData());
  const [settings, setSettings] = useState(dummySettings());

  return (
    <div className="App">
      <div className="display-flex full-height">
        <div>
          <YamlEditor
            value={yaml}
            onChanged={(newData, newSettings) => {
              setData(newData);
              setSettings(newSettings);
            }}
          ></YamlEditor>
        </div>
        <div>
          {data != null && (
            <Board
              data={data}
              settings={settings}
              onDataChanged={() => {
                console.log("Not Implemented.");
              }}
            ></Board>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
